














































































































































































































































import Vue, {VueConstructor} from 'vue';
import VueCompositionAPI, {defineComponent, ref, computed, onMounted, onUnmounted, watch} from '@vue/composition-api';

// @ts-ignore
import MarkerIcon from '../svg/marker.vue';
// @ts-ignore
import AirportIcon from '../svg/airport-marker.vue';
// @ts-ignore
// import TrainStationIcon from '../svg/train-station-marker.vue';
// @ts-ignore
import StayMarker from '../svg/stay-simple-marker.vue';
// @ts-ignore
import CuratedDineMarker from '../svg/dine-curated-marker.vue';
// @ts-ignore
import DineMarker from '../svg/selected-dine-marker.vue';
// @ts-ignore
import CuratedStayMarker from '../svg/stay-curated-marker.vue';
// @ts-ignore
import CuratedExploreMarker from '../svg/explore-curated-marker.vue';
// @ts-ignore
import SelectedExploreMarker from '../svg/explore-selected-marker.vue';

import {install, GlobalMapComponent, defaultMapOptions} from '@mobi-components/global-google-map-components';
import '@mobi-components/global-google-map-components/dist/global-google-map-components.css';
import {getAmexSolution, getRecommendationDetails, loadRecommendationDetails} from '@/store/state/helpers';

import {
  getSolutionDates,
  IDateDescription,
  ISolution,
  UserActivityCategoryEnum,
} from '@mobi-components/global-solution';
import {IMarker, IPolyline} from '@/store/solution/solution-map-handlers';
import {
  getDateActivities,
  getMarkers as getAmexMarkers,
  getPolylinesForTheDate,
  IMarkerExt,
} from '../explore-page/exp-list/utils';

import AmexMarkersCollection from './markers-collection.vue';
import {RecommendationContext} from '@mobi-components/bluesky-utils';
import {Dictionary} from 'vue-router/types/router';
import {SuggestionPois} from '@/views/amex/app-types';
import {useSolutionFilters, VueWithModal} from '../solution-views/summary-filters';
import {ProblmSubmissionRoute} from '@/store/state/global.types';
import {AmexFilter, AmexDropdown, FilterKind} from '@mobi-components/amex-bluesky-components';
import {ToggleComponent} from '@mobi-components/toggle';

import {FilterTag, getListOfSolutionDays} from '@/store/state/utils';
import {useParams} from '@/router/router';
import Circle from '../svg/circle.vue';
import Binoculars from '../svg/binoculars.vue';
import PeopleIcon from '../svg/people.vue';
import StarIcon from '../svg/star-icon.vue';
// import PathIcon from '../svg/path-icon.vue';
// import GemIcon from '../svg/gem-icon.vue';
// import PriceTagIcon from '../svg/price-tag-icon.vue';
// import BadgeTagIcon from '../svg/badge-icon.vue';
import GearIcon from '../svg/gear.vue';
import PlusIcon from '../svg/plus.vue';
import { getBeginningOfTheDay } from '../explore-page/details-view/POIDetailsView/components/utils';

Vue.use(VueCompositionAPI);
Vue.use(install, {
  load: {
    key: process.env.VUE_APP_GOOGLE_API_KEY,
    libraries: 'places',
    v: '3.exp',
  },
  installComponents: false,
});

function useSolutionMap(emit: (x: string, data?: unknown) => void, root: VueWithModal, props: {isMapFull: boolean}) {
  let polylines: IPolyline[] = [];
  const LAYERS_DEFAULT_VALUE = 'All Layers';
  const RECOMMENDED_LAYER = 'Recommended Places';
  const SELECTED_LAYER = 'Selected Places';
  const TRANSIT_LAYER = 'Transit Places';
  const DAYS_FILTER_DEFAULT_VALUE = 'All Days';
  const MATCH_FILTER_DEFAULT_VALUE = 'Select Preference...';
  const LANSE_FILTER_DEFAULT_VALUE = 'Select...';
  const bounds = ref<google.maps.LatLngBounds | null>(null);
  const markersUpdateTrigger = ref('');
  const center = ref<google.maps.LatLngLiteral | null>(null);
  const isDaysFilterActive = ref(false);
  const isMatchesFilterActive = ref(false);
  const isLensesFilterActive = ref(false);
  let solutionMap: google.maps.Map | null = null;

  const isMapFull = computed(() => {
    return props.isMapFull;
  });

  const loadAdditionalExperiences = async () => {
    const params = useParams();
    await loadRecommendationDetails(ProblmSubmissionRoute.SOLUTION, params.value.contextName);
  };

  const {availableSolutionsInterestTags, onFilterClick} = useSolutionFilters(
    root as VueWithModal,
    loadAdditionalExperiences,
  );

  //* Map Layers
  const layersValue = ref(LAYERS_DEFAULT_VALUE);
  const selectedLayers = ref<Set<string>>(new Set());
  const onLayerChange = (value: string) => {
    if (selectedLayers.value.has(value)) {
      selectedLayers.value.delete(value);
      selectedLayers.value = new Set([...selectedLayers.value]);
    } else {
      selectedLayers.value = new Set([...selectedLayers.value, value]);
    }
    if (selectedLayers.value.size === 0) {
      layersValue.value = LAYERS_DEFAULT_VALUE;
    } else {
      layersValue.value = [...selectedLayers.value].join(', ');
    }

    daysValue.value = DAYS_FILTER_DEFAULT_VALUE;
    lensesFilterValue.value = LANSE_FILTER_DEFAULT_VALUE;
    lensesFilterIcon.value = Binoculars;
    matchFilterValue.value = MATCH_FILTER_DEFAULT_VALUE;
    mapReady(solutionMap);
  };
  const isLayersActive = ref(false);
  const layersOptions = [
    {
      icon: Circle,
      value: RECOMMENDED_LAYER,
      label: 'Places matched to you',
      klass: 'orange',
    },
    {
      icon: Circle,
      value: SELECTED_LAYER,
      label: 'Places picked by you',
      klass: 'blue',
    },
    //    {
    //      icon: Circle,
    //      value: TRANSIT_LAYER,
    //      label: 'Airports and Transit Hubs',
    //      klass: 'gray',
    //    },
  ];
  const onLayersClick = () => {
    isDaysFilterActive.value = false;
    isLensesFilterActive.value = false;
    isMatchesFilterActive.value = false;
    isLayersActive.value = !isLayersActive.value;
  };

  //* Days on the map
  const daysValue = ref(DAYS_FILTER_DEFAULT_VALUE);

  const solutionDatesRange = computed<IDateDescription[]>(() => {
    if (!solution.value) {
      return [];
    }
    const params = useParams();
    const context = params.value.contextName;
    const days = getListOfSolutionDays(solution.value, context);
    return getSolutionDates(days).map((x, index) => ({
      ...x,
      label: `Day ${index + 1}`,
      description: formatDate(x.date),
    }));
  });

  const onDatesChange = () => {
    onFilterClick({type: FilterKind.TIME_FRAME});
  };

  const formatDate = (date: Date) => {
    return new Intl.DateTimeFormat(undefined, {day: 'numeric', weekday: 'long', month: 'long'}).format(date);
  };

  const daysFilterOptions = computed(() => {
    return solutionDatesRange.value.map((x) => {
      const dayNumber = x.label;
      const dayActivities = getDateActivities(solution.value, x.date)
        .map((x) => x.activity)
        .filter((x) =>
          [
            UserActivityCategoryEnum.ACCOMMODATION,
            UserActivityCategoryEnum.FLIGHT,
            UserActivityCategoryEnum.RAIL,
            UserActivityCategoryEnum.EXPERIENCE,
            UserActivityCategoryEnum.DINING,
          ].includes(x.category),
        );

      const numberOfPlaces = dayActivities.length;
      return {
        value: formatDate(x.date),
        label: `${dayNumber}, ${numberOfPlaces} Place${numberOfPlaces > 1 ? 's' : ''}`,
        poisCount: numberOfPlaces,
      };
    });
  });

  const onDaysFilterClick = () => {
    isLayersActive.value = false;
    isMatchesFilterActive.value = false;
    isLensesFilterActive.value = false;
    isDaysFilterActive.value = !isDaysFilterActive.value;
  };

  const onDayFilterChange = (day: {value: string; label: string; poisCount: number}) => {
    if (daysValue.value === day.value) {
      daysValue.value = DAYS_FILTER_DEFAULT_VALUE;
    } else {
      daysValue.value = day.value;
    }

    lensesFilterValue.value = LANSE_FILTER_DEFAULT_VALUE;
    lensesFilterIcon.value = Binoculars;
    matchFilterValue.value = MATCH_FILTER_DEFAULT_VALUE;
    layersValue.value = LAYERS_DEFAULT_VALUE;
    selectedLayers.value = new Set();
    isDaysFilterActive.value = false;
    mapReady(solutionMap);
  };

  //* Matches to filter
  const matchFilterValue = ref(MATCH_FILTER_DEFAULT_VALUE);

  const onMatchFilterClick = () => {
    isDaysFilterActive.value = false;
    isLensesFilterActive.value = false;
    isLayersActive.value = false;
    isMatchesFilterActive.value = !isMatchesFilterActive.value;
  };

  const matchFilterOptions = computed(() => {
    if (!solution.value) {
      return [];
    }
    return availableSolutionsInterestTags.value.filter((x) => x.value);
  });

  const onMatchesFilterChange = (value: FilterTag) => {
    if (matchFilterValue.value === value.name) {
      matchFilterValue.value = MATCH_FILTER_DEFAULT_VALUE;
    } else {
      matchFilterValue.value = value.name;
    }

    daysValue.value = DAYS_FILTER_DEFAULT_VALUE;
    lensesFilterValue.value = LANSE_FILTER_DEFAULT_VALUE;
    lensesFilterIcon.value = Binoculars;
    layersValue.value = LAYERS_DEFAULT_VALUE;
    selectedLayers.value = new Set();
    mapReady(solutionMap);
  };

  const onPreferencesChange = () => {
    onFilterClick({type: FilterKind.INTERESTS});
  };

  //* Map lenses
  const lensesFilterValue = ref(LANSE_FILTER_DEFAULT_VALUE);
  const lensesFilterIcon = ref(Binoculars);

  const lensesFilterOptions = [
    {
      name: 'Most Popular',
      description: 'Well-reviewed places',
      icon: PeopleIcon,
    },
    {
      name: 'Highly Rated',
      description: 'Above 4.7 Stars or top 5% of Destination',
      icon: StarIcon,
    },
    //    {
    //      name: 'Convenient Places',
    //      description: 'Fit well with your itinerary places',
    //      icon: PathIcon,
    //    },
    //    {
    //      name: 'Hidden Gem',
    //      description: 'Great places off the beaten path',
    //      icon: GemIcon,
    //    },
    //    {
    //      name: 'Great Deal',
    //      description: 'Good pricing compared to average',
    //      icon: PriceTagIcon,
    //    },
    //    {
    //      name: 'Notable',
    //      description: 'Places with awards or reputation',
    //      icon: BadgeTagIcon,
    //    },
  ];

  const onLensesFilterClick = () => {
    isDaysFilterActive.value = false;
    isLayersActive.value = false;
    isMatchesFilterActive.value = false;
    isLensesFilterActive.value = !isLensesFilterActive.value;
  };

  const onLensesFilterChange = (value: {name: string; icon: VueConstructor}) => {
    if (lensesFilterValue.value === value.name) {
      lensesFilterValue.value = LANSE_FILTER_DEFAULT_VALUE;
      lensesFilterIcon.value = Binoculars;
    } else {
      lensesFilterValue.value = value.name;
      lensesFilterIcon.value = value.icon;
    }

    daysValue.value = DAYS_FILTER_DEFAULT_VALUE;
    matchFilterValue.value = MATCH_FILTER_DEFAULT_VALUE;
    layersValue.value = LAYERS_DEFAULT_VALUE;
    selectedLayers.value = new Set();
    mapReady(solutionMap);
  };

  const clickHandler = () => {
    isDaysFilterActive.value = false;
    isLensesFilterActive.value = false;
    isMatchesFilterActive.value = false;
    isLayersActive.value = false;
  };

  onMounted(() => {
    document.addEventListener('click', clickHandler);
  });
  onUnmounted(() => {
    document.removeEventListener('click', clickHandler);
  });

  //** end of map filters */

  const updateBounds = (allMarkers: readonly IMarker[]) => {
    if (!(window as {google: unknown}).google) {
      return null;
    }
    const allBounds = new google.maps.LatLngBounds();
    [...allMarkers].forEach((m) => {
      allBounds.extend(m.position);
    });
    bounds.value = allBounds;
    center.value = allBounds.getCenter().toJSON();
    return allBounds;
  };

    const getFormattedName = (fullName: string, type: string, day: string) => {
    const cutName = (fullName || '')
      .replace('LUNCH:', '')
      .replace('BREAKFAST:', '')
      .replace('DINNER:', '')
      .trim();
    const typeName = (fullName || '')
      .replace(cutName, '')
      .replace(':', '')
      .trim()
      .toLowerCase();
    const lowerType = type.toLocaleLowerCase();
    const formattedType = (lowerType && lowerType.charAt(0).toUpperCase() + lowerType.slice(1)) || '';
    const formattedTypeName = (typeName && typeName.charAt(0).toUpperCase() + typeName.slice(1)) || '';
    const readableType = formattedTypeName || formattedType;

    return `${readableType} ${day}`.trim();
  };

    const solutionDates = computed<IDateDescription[]>(() => {
    if (!solution.value) {
      return [];
    }
    const days = getListOfSolutionDays(solution.value);
    return getSolutionDates(days).map((x, index) => ({
      ...x,
      label: `Day ${index + 1}`,
      description: formatDate(x.date),
    }));
  });

    const getDayForActivity = (activity: RecommendationContext) => {
    if (!activity) {
      return '';
    }
    const start = getBeginningOfTheDay(new Date(activity.scheduled_start_time * 1000));
    const date = (solutionDates.value || []).find((x) => x.date.valueOf() === start.valueOf());
    return date?.label || '';
  };

  const mapRecommenrationToMarker = (recommendations: RecommendationContext[]): IMarkerExt[] => {
    return recommendations
      .filter((x: RecommendationContext) => {
        return x.location?.lat && x.location?.lng;
      })
      .map((x: RecommendationContext) => {
        const tags = [...new Set(x.tags || [])].map((y) => ({name: y, isActive: false}));
        const day = getDayForActivity(x);
        return {
          id: x.id,
          place: {
            ...x,
            img: x.images.medium,
            numberOfTags: tags.length,
            price: '',
            tags: tags,
            dayDetails: 'Hi',
            day: 'Day 1',



          },
          position: {
            lat: x.location?.lat,
            lng: x.location?.lng,
          },
          type: x.context,
          klass: '',
        };
      });
  };

  const recommendationDetails = computed<Dictionary<SuggestionPois[]>>(() => {
    return getRecommendationDetails();
  });

  const getFirst5Recommendations = (category: UserActivityCategoryEnum) => {
    const excludedCandidateIds =
      solution.value?.activities
        .map((x) => x.source?.candidate_id)
        .filter(Boolean)
        .reduce((res: Record<string, boolean>, x = '') => {
          res[x] = true;
          return res;
        }, {}) || {};
    const exploreRecommendations = (recommendationDetails.value[category] || []).map((x) => x?.pois || []).flat();
    return exploreRecommendations
      .filter((x) => !excludedCandidateIds[x.id])
      .filter((x: RecommendationContext) => {
        return x.location?.lat && x.location?.lng;
      })
      .slice(0, 5);
  };

  const getMarkersFromRecommendations = (
    source: readonly RecommendationContext[],
    condition: boolean,
    context: UserActivityCategoryEnum,
  ) => {
    if (!condition) {
      return [];
    }
    return mapRecommenrationToMarker(source.map((x) => ({...x, context})));
  };

  const filterMatchesAndLenses = (x: IMarkerExt) => {
    return (x.place || {tags: []}).tags.some(
      (t) =>
        (t.name === matchFilterValue.value || matchFilterValue.value === MATCH_FILTER_DEFAULT_VALUE) &&
        (t.name === lensesFilterValue.value || lensesFilterValue.value === LANSE_FILTER_DEFAULT_VALUE),
    );
  };

  const recommendedStay = computed(() => {
    if (selectedLayers.value.size && !selectedLayers.value.has(RECOMMENDED_LAYER)) {
      return [];
    }
    const stays = getMarkersFromRecommendations(
      getFirst5Recommendations(UserActivityCategoryEnum.ACCOMMODATION),
      true,
      UserActivityCategoryEnum.ACCOMMODATION,
    ).filter(filterMatchesAndLenses);
    return stays || [];
  });

  const stayMarkers = computed(() => {
    if (selectedLayers.value.size && !selectedLayers.value.has(SELECTED_LAYER)) {
      return [];
    }
    const date = solutionDatesRange.value.find((x) => formatDate(x.date) === daysValue.value);
    const solutionStayMarkers = getAmexMarkers(
      solution.value,
      UserActivityCategoryEnum.ACCOMMODATION,
      date?.date,
      false,
    ).filter(filterMatchesAndLenses);
    return solutionStayMarkers || [];
  });

  const recommendedExplore = computed(() => {
    if (selectedLayers.value.size && !selectedLayers.value.has(RECOMMENDED_LAYER)) {
      return [];
    }

    const additionalExploreOptions = getMarkersFromRecommendations(
      getFirst5Recommendations(UserActivityCategoryEnum.EXPERIENCE),
      true,
      UserActivityCategoryEnum.EXPERIENCE,
    ).filter(filterMatchesAndLenses);

    const date = solutionDatesRange.value.find((x) => formatDate(x.date) === daysValue.value);
    const solutionExpMarkers = getAmexMarkers(
      solution.value,
      UserActivityCategoryEnum.EXPERIENCE,
      date?.date,
      false,
    ).filter(filterMatchesAndLenses);
    return [...solutionExpMarkers, ...additionalExploreOptions];
  });

  const selectedExperiences = computed<IMarkerExt[]>(() => {
    if (selectedLayers.value.size && !selectedLayers.value.has(SELECTED_LAYER)) {
      return [];
    }

    const date = solutionDatesRange.value.find((x) => formatDate(x.date) === daysValue.value);
    const solutionStayMarkers = getAmexMarkers(
      solution.value,
      UserActivityCategoryEnum.EXPERIENCE,
      date?.date,
      true,
    ).filter(filterMatchesAndLenses);
    return solutionStayMarkers;
  });

  const airportMarkers = computed(() => {
    if (
      lensesFilterValue.value !== LANSE_FILTER_DEFAULT_VALUE ||
      matchFilterValue.value !== MATCH_FILTER_DEFAULT_VALUE ||
      (layersValue.value !== LAYERS_DEFAULT_VALUE && !layersValue.value.includes(TRANSIT_LAYER))
    ) {
      return [];
    }
    const date = solutionDatesRange.value.find((x) => formatDate(x.date) === daysValue.value);
    const flights = getAmexMarkers(solution.value, UserActivityCategoryEnum.FLIGHT, date?.date);
    return flights || [];
  });
  const railMarkers = computed(() => {
    return [];
  });

  const recommendedDine = computed(() => {
    if (selectedLayers.value.size && !selectedLayers.value.has(RECOMMENDED_LAYER)) {
      return [];
    }

    const additionalDineOptions = getMarkersFromRecommendations(
      getFirst5Recommendations(UserActivityCategoryEnum.DINING),
      true,
      UserActivityCategoryEnum.DINING,
    ).filter(filterMatchesAndLenses);

    const date = solutionDatesRange.value.find((x) => formatDate(x.date) === daysValue.value);
    const solutionDineMarkers = getAmexMarkers(
      solution.value,
      UserActivityCategoryEnum.DINING,
      date?.date,
      false,
    ).filter(filterMatchesAndLenses);
    return [...solutionDineMarkers, ...additionalDineOptions];
  });

  const allVisibleMarkers = computed(() => {
    return [
      ...stayMarkers.value,
      ...recommendedStay.value,
      ...recommendedExplore.value,
      ...airportMarkers.value,
      ...railMarkers.value,
      ...recommendedDine.value,
    ];
  });

  const mapReady = (map: google.maps.Map | null) => {
    solutionMap = map;
    markersUpdateTrigger.value = 'ready';

    const date = solutionDatesRange.value.find((x) => formatDate(x.date) === daysValue.value);
    if (allVisibleMarkers.value.length && !date) {
      const allBounds = updateBounds(allVisibleMarkers.value as Readonly<IMarker[]>);
      center.value = allBounds?.getCenter().toJSON() || {lat: 0, lng: 0};
    }

    polylines.forEach((x) => {
      x.polyline.setMap(null);
    });

    if (date && solutionMap) {
      polylines = getPolylinesForTheDate(solution.value, solutionMap, date.date, '#006FCF');
      const paths = polylines.map((x) => x.polyline.getPath());
      const allBounds = new google.maps.LatLngBounds();
      paths.forEach((path) => path.forEach((point) => allBounds.extend(point)));
      center.value = allBounds?.getCenter().toJSON() || {lat: 0, lng: 0};
      bounds.value = allBounds;
    }
  };

  const solution = computed<ISolution | null>(() => {
    return getAmexSolution();
  });

  watch(isMapFull, () => {
    mapReady(solutionMap);
  });
  watch(solution, () => {
    mapReady(solutionMap);
  });

  const hoverItem = ref('');

  const onHover = (id: string) => {
    hoverItem.value = id;
  };

  const selectedDine = computed<IMarkerExt[]>(() => {
    if (selectedLayers.value.size && !selectedLayers.value.has(SELECTED_LAYER)) {
      return [];
    }

    const date = solutionDatesRange.value.find((x) => formatDate(x.date) === daysValue.value);
    const solutionStayMarkers = getAmexMarkers(
      solution.value,
      UserActivityCategoryEnum.DINING,
      date?.date,
      true,
    ).filter(filterMatchesAndLenses);
    return solutionStayMarkers;
  });

  const onMarkerClick = (id: string) => {
    emit('show-details', id);
  };

  const onToggleMap = () => {
    emit('toggle-map');
  };

  return {
    center,
    mapReady,
    mapOptions: {
      ...defaultMapOptions,
      zoomControlOptions: {
        ...defaultMapOptions.zoomControlOptions,
        position: 8,
      },
    },
    bounds,
    onMarkerClick,
    markersUpdateTrigger,
    hoverItem,
    onHover,
    stayMarkers,
    selectedDine,
    selectedExperiences,
    recommendedDine,
    recommendedStay,
    recommendedExplore,
    onToggleMap,
    diningCtegory: UserActivityCategoryEnum.DINING,
    exploreCategory: UserActivityCategoryEnum.EXPERIENCE,
    stayCategory: UserActivityCategoryEnum.ACCOMMODATION,
    layersValue,
    selectedLayers,
    layersOptions,
    onDatesChange,
    daysValue,
    DAYS_FILTER_DEFAULT_VALUE,
    daysFilterOptions,
    isLayersActive,
    isDaysFilterActive,
    onLayersClick,
    onDaysFilterClick,
    onLayerChange,
    onDayFilterChange,
    isMatchesFilterActive,
    MATCH_FILTER_DEFAULT_VALUE,
    matchFilterValue,
    onMatchFilterClick,
    onMatchesFilterChange,
    onPreferencesChange,
    matchFilterOptions,
    isLensesFilterActive,
    lensesFilterIcon,
    lensesFilterValue,
    lensesFilterOptions,
    onLensesFilterChange,
    onLensesFilterClick,
    LANSE_FILTER_DEFAULT_VALUE,
    airportMarkers,
  };
}

const AmexSolution = defineComponent({
  components: {
    GlobalMapComponent,
    MarkerIcon,
    CuratedDineMarker,
    CuratedStayMarker,
    CuratedExploreMarker,
    AmexMarkersCollection,
    AirportIcon,
    StayMarker,
    AmexFilter,
    ToggleComponent,
    AmexDropdown,
    DineMarker,
    SelectedExploreMarker,
    CircleIcon: Circle,
    GearIcon,
    PlusIcon,
  },
  props: {
    mainMarker: {
      type: Object,
      default: null,
    },
    isMapActive: {
      type: Boolean,
      default: false,
    },
    isMapFull: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, {emit, root}) {
    return {
      ...useSolutionMap(emit, root as VueWithModal, props),
    };
  },
});

export default AmexSolution;
